module.exports = __webpack_public_path__ + "img/walkthrough_illust29@2x.cc2e8c1e.png";